"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var SvgFull = function SvgFull(props) {
  return React.createElement("svg", __assign({
    width: 1792,
    height: 1792,
    viewBox: "0 0 1792 1792"
  }, props), React.createElement("g", {
    id: "aba759fb-e148-43b4-b448-73cdd102344a",
    "data-name": "\\u30E9\\u30D9\\u30EB"
  }, React.createElement("rect", {
    y: 623,
    width: 1792,
    height: 546
  }), React.createElement("rect", {
    x: 174.43,
    y: 0.2,
    width: 1443.13,
    height: 181
  }), React.createElement("rect", {
    x: 174.43,
    y: 312.2,
    width: 1443.13,
    height: 181
  }), React.createElement("rect", {
    x: 174.43,
    y: 1299.2,
    width: 1443.13,
    height: 181
  }), React.createElement("rect", {
    x: 174.43,
    y: 1611.2,
    width: 1443.13,
    height: 181
  })));
};
exports.default = SvgFull;